import './fyscatering/style';
import FormStructure from './fyscatering/form_structure';

export default FormStructure;